import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';
import { PermissionWrapper } from 'src/pages/auth/hooks/permissionWrapper';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import ChannelStepView from '../step';
import ChannelEdit from '../channelEdit';
import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------
const ChannelListPage = lazyWithReload(() => import('../list'));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const channelRoutes: RouteObject[] = [
  {
    path: 'channel',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <ChannelListPage /> },
      {
        path: 'step',
        element: (
          <PermissionWrapper module="channel" action="create">
            <ChannelStepView />
          </PermissionWrapper>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionWrapper module="channel" action="edit">
            <ChannelEdit />
          </PermissionWrapper>
        ),
      },
    ],
  },
];
